import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { CircularProgress } from '@mui/material';
import { DoughnutChartStyles } from './Style'
import { ratingColors4, ratingListLabel } from 'keys/rating';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { map } from 'lodash';
import { SmallSpace } from 'styles/GlobalStyle';

ChartJS.register(ArcElement, Tooltip, Legend,
    // ChartDataLabels
);

const options = {
    responsive: true,
    plugins: {
        datalabels: {
            display: false, // Hide labels for this Bar component
        },
        legend: {
            display: false,
        },
        // datalabels: {
        //     anchor: 'center',
        //     align: 'center',
        //     offset: 20,
        //     formatter: (value, context) => {
        //         return `${value.toFixed(0)}%`;
        //     }
        // },
        title: {
            display: false,
        },
        tooltip: {
            titleAlign: "center",
            bodyAlign: "center",
            footerAlign: "center",
            displayColors: false,
            // callbacks: {
            //     label: function ({ formattedValue }) {
            //         return !formattedValue || `${Number(formattedValue)?.toFixed(0)}%`
            //     },
            //     labelPointStyle: () => ({ display: "none" }),
            //     labelPointStyle: () => ({ textAlign: "end" })
            // }
        }
    },
};

const ChartComponent = (props) => {
    const { segmentations, name } = props

    const colors = map(segmentations, "color")
    const values = map(segmentations, "value")
    const labels = map(segmentations, "label")

    return (
        <DoughnutChartStyles>
            <div className='title'>
                {name}
            </div>
            <div className='sub-title'>
                {`פילוח כמות ${labels.join(' ו')}`}
            </div>
            <SmallSpace />
            <div className='doughnut'>
                <Doughnut
                    data={{
                        labels: labels,
                        datasets: [{
                            backgroundColor: colors,
                            // label: labels,
                            data: values
                        }]
                    }}
                    options={options}
                />
            </div>
        </DoughnutChartStyles>
    );
};

export default ChartComponent;